module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "calibre1",
    attrs: {
      "id": "Death_In_the_12th_House-4.html",
      "xml:lang": "en-US"
    }
  }, [_c('div', {
    staticClass: "calibre1"
  }, [_c('p', {
    staticClass: "ct",
    attrs: {
      "id": "toc_marker-5"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/OEBPS/Death_In_the_12th_House3#Contents-A"
    }
  }, [_vm._v("Dedication")])]), _vm._v(" "), _c('p', {
    staticClass: "body-center"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("For music and astrology"), _c('br', {
    staticClass: "calibre3"
  }), _vm._v("The two great loves of my life"), _c('br', {
    staticClass: "calibre3"
  }), _vm._v("Forever in harmony")])]), _vm._v(" "), _c('p', {
    staticClass: "body-center"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("And for Goldie"), _c('br', {
    staticClass: "calibre3"
  }), _vm._v("Constant in an ever changing universe")])]), _vm._v(" "), _c('p', {
    staticClass: "body-center"
  })])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-f0e7d590","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/OEBPS/Death_In_the_12th_House-4.vue
// module id = 69
// module chunks = 0